<ng-template #noteModal let-modal class="">
	<div class="modal-header">
		<h4 class="modal-title">{{ formAction == 'edit' ? 'Update' : 'Add' }} Note</h4>
		<button type="button" aria-label="Close" class="close" (click)="modal.dismiss()"><span aria-hidden="true">&times;</span></button>
	</div>
	<div class="modal-body">
		<div class="alert alert-danger" role="alert" *ngIf="inValidNote">Please enter a valid note minimum of 4 characters</div>
		<textarea class="form-control form-control" rows="5" #note appFocus id="note" [ngClass]="inValidNote ? 'border border-danger' : ''">{{ formAction == 'edit' ? n?.note : '' }}</textarea>
	</div>
	<div class="modal-footer">
		<div class="btn-group float-left" role="group">
			<button type="button" [disabled]="isSubmitting" class="btn btn-success" (click)="formAction == 'edit' ? editNote(n, note.value, noteModal) : addNote(note.value, noteModal)">Save Note</button>
			<button type="button" class="btn btn-dark" (click)="modal.dismiss()">Cancel</button>
		</div>
	</div>
</ng-template>
<div class="card mt-0 noprint">
	<div class="card-header">
		<h5>Notes<i class="fa float-right mt-2 fa-plus" triggers="mouseenter:mouseleave" ngbPopover="Add Note" aria-hidden="true" (click)="showWindow('add', '', noteModal)"></i></h5>
	</div>
	<div *ngIf="notes.length >= 1" id="note" class="overflow-auto" style="max-height: 25vh; min-height: 400px">
		<app-component-loader [loading]="LoaderService.loadingNotes"></app-component-loader>
		<div *ngFor="let note of notes; let index = index" class="card-body border-bottom">
			<div class="mb-4">
				<child-note-detail [note]="note" [loading]="loading"></child-note-detail>
			</div>

			<div class="float-right" style="margin-top: -16px" ng-class-odd="odd">
				<button class="fa fa-trash-o btn  btn-outline-danger no-bg" aria-hidden="true" [ngbPopover]="alertContent" popoverTitle=" Delete Note?" placement="left"></button>
				<ng-template #alertContent>
					<div class="d-flex justify-content-center">
						<button type="button" (click)="removeNote(note)" class="btn btn btn-success btn-md mr-2"><i class="fa fa-check-circle-o mr-1" aria-hidden="true"></i>Yes</button>
						<button type="button" class="btn btn btn-danger btn-md"><i class="fa fa-ban mr-1" aria-hidden="true"></i>No</button>
					</div>
				</ng-template>
				<button class="fa fa-pencil btn  btn-outline-success no-bg ml-1" triggers="mouseenter:mouseleave" ngbPopover="Edit Note" aria-hidden="true" (click)="showWindow('edit', note, noteModal)"></button>
			</div>
		</div>
	</div>
	<div *ngIf="notes.length < 1" id="note" class="overflow-auto" style="max-height: 25vh; min-height: 25vh">
		<p class="text-center mt-2">
			Your notes will show up here.
			<button class="btn btn-sm btn-dark" (click)="showWindow('add', '', noteModal)">Click here</button>
			to add your first note.
		</p>
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ccc" width="150" height="150">
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
		</svg>
	</div>
</div>
<div class="print" id="all-notes-print">
	<h3 *ngIf="notes.length >= 1" >Child Notes</h3>
	<div *ngFor="let note of notes; let index = index" id="note-print">
		<p class="mb-0 mt-3">
			{{ note.note }}
		</p>
		<p class="text-capitalize">{{ note.createdBy }} <cite title="Source Title"> {{ note.createdDate | date }}</cite></p>
	</div>
</div>
